/**
 * Rotating Highlighted Text - SIMPLE & CORRECT
 * Only highlighted text animates
 * Space is removed completely with display: none
 */

class RotatingHighlightedText {
  constructor() {
    this.animationDuration = 3000;     // Show for 3 seconds
    this.transitionDuration = 500;     // Animation takes 500ms
    this.init();
  }

  init() {
    document.querySelectorAll('.image-banner__title').forEach((titleEl) => {
      this.setupRotation(titleEl);
    });

    this.observeNewSlides();
  }

  setupRotation(titleEl) {
    const highlightedTexts = titleEl.querySelectorAll('.highlighted-text');

    if (highlightedTexts.length <= 1) {
      return;
    }

    titleEl.highlightedTexts = highlightedTexts;
    titleEl.currentHighlightIndex = 0;
    titleEl.isAnimating = false;

    // Initialize: show first text only
    this.initializeHighlights(titleEl);

    // Start rotating
    this.startRotation(titleEl);
  }

  initializeHighlights(titleEl) {
    const { highlightedTexts } = titleEl;

    highlightedTexts.forEach((span, index) => {
      span.style.animation = 'none';

      if (index === 0) {
        // First text visible
        span.classList.add('highlight-visible');
        span.classList.remove('highlight-hidden');
      } else {
        // All others hidden
        span.classList.remove('highlight-visible');
        span.classList.add('highlight-hidden');
      }

      void span.offsetHeight;
      span.style.animation = '';
    });
  }

  updateHighlights(titleEl) {
    const { highlightedTexts, currentHighlightIndex } = titleEl;

    highlightedTexts.forEach((span, index) => {
      span.style.animation = 'none';

      if (index === currentHighlightIndex) {
        // Show this one
        span.classList.remove('highlight-hidden');
        span.classList.add('highlight-visible');
      } else {
        // Hide all others
        span.classList.remove('highlight-visible');
        span.classList.add('highlight-hidden');
      }

      void span.offsetHeight;
      span.style.animation = '';
    });
  }

  startRotation(titleEl) {
    const rotate = () => {
      if (titleEl.highlightedTexts.length <= 1) return;

      setTimeout(() => {
        if (!titleEl.isAnimating) {
          titleEl.isAnimating = true;

          // Move to next text
          titleEl.currentHighlightIndex =
            (titleEl.currentHighlightIndex + 1) % titleEl.highlightedTexts.length;

          // Update visibility and trigger animation
          this.updateHighlights(titleEl);

          setTimeout(() => {
            titleEl.isAnimating = false;
          }, this.transitionDuration);
        }
      }, this.animationDuration);

      titleEl.rotationTimeout = setTimeout(
        rotate,
        this.animationDuration + this.transitionDuration
      );
    };

    rotate();
  }

  observeNewSlides() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              const titleEl = node.querySelector?.('.image-banner__title');
              if (titleEl) {
                this.setupRotation(titleEl);
              }
            }
          });
        }
      });
    });

    const carouselContainer = document.querySelector('[data-carousel-container]');
    if (carouselContainer) {
      observer.observe(carouselContainer, {
        childList: true,
        subtree: true,
      });
    }
  }

  destroy() {
    document.querySelectorAll('.image-banner__title').forEach((titleEl) => {
      if (titleEl.rotationTimeout) {
        clearTimeout(titleEl.rotationTimeout);
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new RotatingHighlightedText();
  });
} else {
  new RotatingHighlightedText();
}

document.addEventListener('shopify:section:load', () => {
  new RotatingHighlightedText();
});